import Button from 'react-bootstrap/Button';

function ReportsActions({ getAll, openReportsCreationModal }) {
  return (
    <div className="d-flex gap-3">
      <Button className="bo-button bo-w-120" onClick={getAll}>
        Refresh
      </Button>
      <Button className="bo-button bo-w-120" onClick={openReportsCreationModal}>
        Create New
      </Button>
    </div>
  );
}

export default ReportsActions;
